ko.components.register('domain-check', {
	viewModel: function(params) {
		var self = this;

		self.id = ko.observable(params.id);
	    self.status = ko.observable(params && params.status || 0);

		self.loading = ko.observable(false);

		self.isPending = ko.pureComputed(function(){ return self.status() == 1; });
	    self.isActive = ko.pureComputed(function(){ return self.status() == 2; });

	    self.toggle = function() {
	    	if(self.loading() || !self.id() || self.isActive())
	    		return;
    		self.loading(true);
			App.ajaxRequest('domain/check', {id: self.id()})
				.always(function(){ self.loading(false); })
				.done(function(r){
					if(r) {
						if(r.ok)
							self.status(r.status);
						if(r.error)
							alert(r.error);
					}
				});
		};
	},
	template: "<button class=\"js-domain-check\" data-bind=\"click: toggle\">\n\t<span data-bind=\"css: {\n\t\t'ic ic-clock': isPending(),\n\t\t'ic ic-refresh': !isPending() && !isActive(),\n\t\t'ic ic-lock': isActive()\n\t}\"></span>\n</button>"
});